import { render, staticRenderFns } from "./productLabelManage.vue?vue&type=template&id=6cdebbfa&scoped=true"
import script from "./productLabelManage.vue?vue&type=script&lang=js"
export * from "./productLabelManage.vue?vue&type=script&lang=js"
import style0 from "./productLabelManage.vue?vue&type=style&index=0&id=6cdebbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdebbfa",
  null
  
)

export default component.exports